import React from 'react';
import Select, { SelectOption } from 'src/shared/components/select/Select';

import { SamplingEventFilterData } from 'src/shared/hooks/useProjectFilters';
import styles from './SamplingEventFilter.module.scss';

export type SelectedDateRange = {
    startDate: string;
    endDate: string;
};

type DateFilterProps = {
    testId?: string;
    selectedSamplingEvent: SamplingEventFilterData | null;
    samplingEventFilterData: SamplingEventFilterData[];
    onChange: (samplingEvent: SamplingEventFilterData) => void;
    width?: string | number;
};

const SamplingEventFilter = (props: DateFilterProps) => {
    const { selectedSamplingEvent, samplingEventFilterData, onChange, width, testId = 'sampling-event-filter' } = props;

    if (!samplingEventFilterData || samplingEventFilterData.length === 0) {
        return (
            <Select
                testId={testId}
                width={width}
                options={[]}
                onChange={() => {}}
                selectedValue={undefined}
                placeholder='None available'
                isDisabled
            />
        );
    }

    const newSamplingEventOptions: SelectOption[] = samplingEventFilterData.map((option, i) => {
        const selectedLabel = `Year ${option.year}, Event ${option.event}`;
        return {
            label: (
                <div className={styles.samplingEventsLabelWrapper}>
                    <span className={styles.labelNumber}>{i + 1}</span>
                    <div className={styles.labelText}>
                        <span>{selectedLabel}</span>
                        <span className={styles.row2}>{option.name}</span>
                    </div>
                </div>
            ),
            value: i + '',
            selectedLabel,
        };
    });

    const selectedLabel = selectedSamplingEvent ? `Year ${selectedSamplingEvent.year}, Event ${selectedSamplingEvent.event}` : '';
    const selectedOptionIndex = newSamplingEventOptions.findIndex(option => option.selectedLabel === selectedLabel);
    const selectedValue = (selectedOptionIndex >= 0 ? selectedOptionIndex : 0) + '';

    return (
        <Select
            testId={testId}
            width={width}
            options={newSamplingEventOptions}
            onChange={value => onChange(samplingEventFilterData[+value])}
            selectedValue={selectedValue}
            renderValueFormatter={value => {
                return newSamplingEventOptions[+value]?.selectedLabel || '';
            }}
        />
    );
};

export default SamplingEventFilter;
